module.exports = __webpack_public_path__ + "img/visibility_icon.c958505c.svg";